const PlatformType = Object.freeze({
  Admin: 0,
  Manager: 1,
  FunNow: 2,
  System: 3,
  Partner: 4,
  RwG: 5
})

export {
  PlatformType
}
